const API_CONFIG = {
  // Base URL for the API - can be changed based on environment
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:9091',
  
  // PDF unlocker endpoint
  PDF_UNLOCK: '/pdf/unlock',
  
  // PDF compression endpoint
  PDF_COMPRESS: '/pdf/compress',
  
  // Full URL for PDF unlocker
  getPdfUnlockUrl: function() {
    return `${this.BASE_URL}${this.PDF_UNLOCK}`;
  },
  
  // Full URL for PDF compression
  getPdfCompressUrl: function() {
    return `${this.BASE_URL}${this.PDF_COMPRESS}`;
  }
};

export default API_CONFIG; 